<template>
  <div class="addBaseInfo">
    <div class="title">
      实名认证<Back v-if="step === 1" />
      <!-- <span
        class="btnGoback"
        @click="step === 1 ? $router.go(-1) : (step = 1)"
        ><i class="icon_arrow_left"></i>返回</span
      > -->
    </div>
    <div v-if="step === 1" class="step1">
      <!-- style="margin-bottom:38px;font-size:14px" -->
      <div class="tip">
        <Icon
          className="icon_warning"
          style="width: 20px;
    height: 20px;
    margin-right: 10px;
    "
        />基于国家数据平台的信息安全规范，溯源优才平台用户均为实名用户，请先完成实名认证。此身份信息仅用于国家级大数据平台进行实名认证，不会向任何第三方泄露。为顺利完成实名认证，请准确输入您的个人身份信息！
      </div>
      <!-- <div class="cost">费用：<span>￥1</span></div> -->
      <el-form
        class="form"
        :modal="form"
        label-position="left"
        label-width="100px"
      >
        <el-form-item label="真实姓名：">
          <el-input
            v-model="form.name"
            placeholder="输入您的姓名"
            style="width:299px"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号："
          ><el-input
            v-model="form.idCard"
            placeholder="输入您的身份证号"
            style="width:299px"
          ></el-input
        ></el-form-item>
        <el-form-item label="手机号："
          ><el-input
            :disabled="true"
            v-model="form.phoneNumber"
            placeholder="输入您的手机号"
            style="width:299px"
          ></el-input
        ></el-form-item>
      </el-form>

      <el-button type="primary" style="margin-top:8px" @click="certification"
        >提交并进入下一步</el-button
      >
      <div class="diffrence">
        <div class="diffTitle">实名用户权益：</div>
        <div class="diffList">
          <div class="diffItem">
            <i class="realIcon real_cksj"></i>
            <div>查看数据</div>
          </div>
          <div class="diffItem">
            <i class="realIcon real_ztsj"></i>
            <div>自填数据</div>
          </div>
          <div class="diffItem">
            <i class="realIcon real_kwsq"></i>
            <div>勘误申请</div>
          </div>
          <div class="diffItem">
            <i class="realIcon real_ydsz"></i>
            <div>应答设置</div>
          </div>
          <div class="diffItem">
            <i class="realIcon real_cybg"></i>
            <div>查验报告</div>
          </div>
          <div class="diffItem">
            <i class="realIcon real_cytr"></i>
            <div>查验他人</div>
          </div>
        </div>
        <!-- <div class="real">
          <div class="diffTitle">
            实名用户权益
          </div>
          <div class="diffList">
            <div class="diffItem">
              <i class="realIcon real_cksj"></i>
              <p>查看数据</p>
              <p>查看所有数据</p>
            </div>
            <div class="diffItem">
              <i class="realIcon real_ztsj"></i>
              <p>自填数据</p>
              <p>可以自填数据</p>
            </div>
            <div class="diffItem">
              <i class="realIcon real_kwsq"></i>
              <p>勘误申请</p>
              <p>可对信息发起勘误 申请</p>
            </div>
            <div class="diffItem">
              <i class="realIcon real_cksj"></i>
              <p>应答设置</p>
              <p>对他人查看设置 应答</p>
            </div>
          </div>
        </div>

        <div class="noReal">
          <div class="vs">VS</div>
          <div
            style="flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;"
          >
            <div class="diffTitle">非实名用户</div>
            <div class="diffList">
              <div class="diffItem">
                <i class="realIcon noReal_cksj"></i>
                <p>查看数据</p>
                <p>无法查看所有数据 详情</p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div class="step2" v-if="step === 2">
      <div class="certificationInfo">
        <div>
          <div>真实姓名：{{ form.name }}</div>
          <div>手机号：{{ form.phoneNumber }}</div>
          <div>身份证号：{{ form.idCard }}</div>
        </div>
        <Btn
          btnText="返回修改"
          :fontSize="14"
          :radius="20.5"
          :height="41"
          :width="124"
          className="primary"
          @handleClick="step = 1"
        />
      </div>

      <div class="introduce">
        <Icon
          className="icon_warning"
          style="width: 20px;
    height: 20px;
    margin-right: 10px;
    top: 4px;
    position: relative;"
        />
        <span
          >本次服务由国家级大数据平台提供实名匹配认证，认证成功后可查看数据档案详情，补充自填信息，申请勘误，生成个人信息报告。请仔细核实认证信息，若因数据档案填写失误造成认证失败，此次认证费用将无法退还。</span
        >
      </div>

      <!-- <div class="money">支付金额：<span>￥1</span></div>
      <div class="qrcode"></div>
      
      <div class="payTip">
        <i>weichat</i><i>alipay</i>使用微信/支付宝扫码支付
      </div> -->
      <div class="payLayout">
        <div class="payTip">
          确认信息无误，请使用<span>微信</span>扫码支付；扫码支付完成后，请点击下方按钮，进入下一步。
        </div>
        <!-- <div class="payTip">扫码支付完成后，请点击下方按钮，进入下一步。</div> -->
        <div class="payMain">
          <QRcode
            v-if="qrcode.code_url"
            :QRlink="qrcode.code_url"
            :qrwidth="190"
            :qrheight="190"
          />
          <div class="payInfo">
            <div>
              支付金额：
              <span class="money">
                ￥<span>{{ payInfo.realNameAuthentication / 100 }}</span>
              </span>
            </div>

            <div class="timerLimit">
              二维码有效时长：<count-down ref="countdown" />
            </div>
            <div class="refresh">
              如无法支付或者二维码已过期请点击
              <span @click="handleRefresh">刷新</span>
            </div>
            <Btn
          btnText="已支付，进入下一步"
          className="primary"
          :fontSize="14"
          :height="41"
          :width="198"
          :radius="20.5"
          style="margin-top: 45px;"
          @handleClick="handleResult"
        />
          </div>
        </div>
      </div>
      <!-- <div style="text-align:center;padding-top:36px">
        <Btn
          btnText="已支付，进入下一步"
          className="primary"
          :fontSize="14"
          :height="41"
          :width="198"
          :radius="20.5"
          @handleClick="handleResult"
        />
      </div> -->
    </div>
    <div class="step3" v-if="step === 3">
      <img
        src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/success.png"
        alt=""
      />
      <div class="status">实名认证成功！</div>
      <Btn
        btnText="返回数据档案"
        className="primary"
        :height="41"
        :width="124"
        :radius="20.5"
        :fontSize="14"
        @handleClick="$router.push('/personal/index')"
      />
    </div>
    <div class="step4" v-if="step === 4">
      <img
        src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/failed.png"
        alt=""
      />
      <div class="status">实名认证失败！</div>
      <div class="description">
        您提供的实名认证信息有误，认证失败。请提供准确信息，请重新认证
      </div>
      <Btn
        btnText="重新认证"
        className="primary"
        :height="41"
        :width="124"
        :radius="20.5"
        :fontSize="14"
        @handleClick="step = 1"
      />
    </div>
    <div class="step5" v-if="step === 5">
      <img
        src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/unusual.png"
        alt=""
      />
      <div class="status">系统发生了一点异常...</div>
      <div class="description">
        因数据库异常暂时无法进行实名认证，请稍后重试，此次认证费用将原路退还。
      </div>
      <Btn
        btnText="重新认证"
        className="primary"
        :height="41"
        :width="124"
        :radius="20.5"
        :fontSize="14"
        @handleClick="step = 1"
      />
    </div>
  </div>
</template>

<script>
import SiderBar from "@/components/SiderBar";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import {
  realNameAuth,
  // pay,
  realNameAuthenticationResultCheck,
  getUserInfo
} from "@/api/user";
import { payInfo } from "@/api/pay";
import QRcode from "../../components/QRcode.vue";
import Btn from "../../components/Btn.vue";
import CountDown from "../../components/CountDown.vue";
import Icon from "../../components/Icon.vue";
import Back from "@/components/Back";
import { webSocketMixin } from '@/utils/mixins.js'

export default {
  components: { SiderBar, Header, Footer, QRcode, Btn, CountDown, Icon, Back },
  mixins: [webSocketMixin],
  data() {
    return {
      form: {
        name: undefined,
        phoneNumber: JSON.parse(sessionStorage.getItem("userInfo")).username,
        idCard: undefined
      },
      step: 1,
      qrcode: {
        code_url: "http://www.baidu.com",
        orderId: ""
      },
      payInfo: {}
    };
  },
  created() {
    this.getPayInfo();
    // this.form.idCard=this.$route.query.idCard
    if (
      this.$route.query.idCard !== "" &&
      this.$route.query.idCard !== undefined
    ) {
      this.form = {
        name: JSON.parse(sessionStorage.getItem("userInfo")).name,
        phoneNumber: JSON.parse(sessionStorage.getItem("userInfo")).username,
        idCard:
          this.$route.query.idCard ||
          JSON.parse(sessionStorage.getItem("userInfo")).idCard,
        authType: this.$route.query.idCard === "" ? "FIRST" : "PHONE_REFRESH"
      };
    }
  },
  beforeDestroy() {
    this._closeSocket()
  },
  methods: {
    getPayInfo() {
      payInfo().then(res => {
        // console.log(res);
        this.payInfo = res.data.d;
      });
    },
    certification() {
      this._initSocket()
      this._socket.onmessage = (e) => {
        let { data } = e
        if (data) {
          data = JSON.parse(data)
          console.log(data)
          const { type, paySuccess, message } = data
          if (type === 2 && paySuccess) {
            this.handleResult()
          }
        }
      }
      realNameAuth({
        ...this.form,
        webSocketUserId: this._socketId
      }).then(res => {
        if (res.data.c === 200) {
          this.qrcode = res.data.d;
          this.step = 2;
        }
      });
    },
    async getUserInfo() {
      await getUserInfo().then(res => {
        sessionStorage.setItem("userInfo", JSON.stringify(res.data.d));
      });
    },
    handleResult() {
      realNameAuthenticationResultCheck().then(res => {
        // console.log(res.data.d);
        if (res.data.c === 200) {
          switch (res.data.d) {
            case "认证成功":
              this.step = 3;
              // getUserInfo().then(res => {
              //   sessionStorage.setItem("userInfo", JSON.stringify(res.data.d));
              // });
              this.getUserInfo();
              break;
            case "认证失败":
              this.step = 4;
              break;
            case "认证异常":
              this.step = 5;
              break;
            default:
              break;
          }
        } else {
          this.$message.error(res.data.m);
        }
      });
    },
    handleRefresh() {
      this.$refs.countdown.handleReset();
      this.certification();
    }
  }
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.flex_column {
  flex-direction: column;
}

.addBaseInfo {
  display: flex;
  margin-top: 39px;
  flex: 1;
  margin-bottom: 70px;
  background: #fff;
  margin-left: 17px;
  padding: 38px 41px 60px 40px;
  flex-direction: column;
  min-height: 702px;
  box-sizing: border-box;
  .title {
    font-size: 20px;
    color: #393939;
    margin-bottom: 32px;
    font-weight: bold;
    .btnGoback {
      float: right;
      color: #8d8d8d;
      font-weight: 500;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .form {
    .el-form-item__label {
      color: #6e6e6e;
    }
    .el-input__inner {
      width: 321px;
      height: 37px;
      border-color: #d7d7d7;
    }
    .to {
      margin: 0 5.5px;
    }
    .el-date-editor {
      width: 144px;

      .el-input__inner {
        width: 144px;
        height: 37px;
        border-color: #d7d7d7;
      }
    }

    .subTitle {
      margin-top: 43px;
      margin-bottom: 27px;
      font-size: 16px;
      color: #393939;
      font-weight: bold;
    }
  }
  .addBtn {
    background: none;
    width: 114px;
    height: 39px;
    border-radius: 19.5px;
    color: #6e6e6e;
    border: 1px solid #dddddd;
    outline: none;
    margin-bottom: 36px;
  }
  .el-button--primary {
    background: #3a61b1;
    border: 0;
    width: 124px;
    height: 41px;
    border-radius: 20.5px;
  }
  .step1 {
    .tip {
      background: #fffbfb;
      border: 1px solid #ffb3a4;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #7e7e7e;
      line-height: 20px;
      padding: 20px 22px 24px 54px;
      box-sizing: border-box;
      position: relative;
      margin-bottom: 30px;
      .icon_warning {
        position: absolute;
        left: 20px;
      }
    }
    .cost {
      margin-bottom: 37px;
      margin-top: 26px;
      span {
        color: #ff5129;
        font-size: 20px;
        position: relative;
        top: 2px;
      }
    }
    .diffrence {
      border: 1px solid #d9d9d9;
      // padding: 46px 57px 57px 57px;
      padding: 46px 58px 25px 58px;
      display: flex;
      flex-direction: column;
      margin-top: 45px;
      // margin-bottom: 58px;

      .diffTitle {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #393939;
      }
      .real {
        display: flex;
        flex: 1;
        // align-items: center;
        // justify-content: center;
        flex-direction: column;
      }
      .noReal {
        flex: 1;
        display: flex;
        .vs {
          font-size: 43.5px;
          color: rgba(57, 57, 57, 0.36);
          display: flex;
          align-items: center;
        }
        .diffList {
          .diffItem {
            margin-right: 0;
          }
        }
        // width: 369px;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        // flex-direction: column;
      }
      .diffList {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        // align-items: center;
        // justify-content: center;
        // text-align: center;
        flex-wrap: wrap;
        margin-top: 28px;
        .diffItem {
          width: 64px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          margin-right: 113px;
          margin-bottom: 40px;
          // &:nth-child(2n) {
          //   margin-right: 0;
          // }
          // &:nth-child(3),
          // &:nth-child(4) {
          //   margin-bottom: 0;
          // }
          p {
            &:nth-child(2) {
              font-size: 16px;
              color: #393939;
              margin-bottom: 10px;
            }
            &:last-child {
              font-size: 14px;
              color: #6e6e6e;
              line-height: 30px;
            }
          }
          .realIcon {
            background-size: cover !important;
            width: 63px;
            height: 62px;
            display: inline-block;
            margin-bottom: 26px;
          }
          .real_cksj {
            background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/real_cksj.png")
              no-repeat;
          }
          .real_ztsj {
            background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/real_ztsj.png")
              no-repeat;
          }
          .real_kwsq {
            background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/real_kwsq.png")
              no-repeat;
          }
          .real_ydsz {
            background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/real_ydsz.png")
              no-repeat;
          }
          .real_cybg {
            background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/real_cybg.png")
              no-repeat;
          }
          .real_cytr {
            background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/real_cytr.png")
              no-repeat;
          }
          .noReal_cksj {
            background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/noReal_cksj.png")
              no-repeat;
          }
        }
      }
    }
    .el-button--primary {
      background: #3a61b1;
      border: 0;
      width: 156px;
      height: 41px;
      border-radius: 20.5px;
    }
  }
  .step2 {
    font-size: 14px;
    color: #6e6e6e;
    .introduce {
      line-height: 30px;
      span {
        //   font-size: 14px;
      }
    }
    .payLayout {
      box-shadow: 0px 0px 11px 0px #e6e6e6;
      padding: 40px 0 40px 49px;
      margin-top: 30px;
      font-size: 16px;
      .payTip {
        font-size: 14px;
        color: #393939;
        margin-bottom: 36px;
        margin-top: 0;
        span {
          color: #ff5129;
        }
      }
      .payMain {
        display: flex;
        .payInfo {
          margin-left: 32px;
          .money {
            color: #ff5129;
            font-size: 20px;
            margin-bottom: 25px;
            span {
              font-size: 36px;
            }
          }
          .timerLimit {
            margin-bottom: 5px;
            margin-top: 10px;
            span {
              color: #ff5129;
            }
          }
          .refresh {
            font-size: 16px;
            span {
              color: #47a2ff;
              cursor: pointer;
            }
          }
        }
      }
    }
    .certificationInfo {
      // margin-top: 22px;
      margin-bottom: 23px;
      background: #f0f2f5;
      padding: 20px 53px 23px 32px;
      line-height: 28px;
      border-radius: 2px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .money {
      margin-top: 37px;
      font-size: 16px;
      span {
        font-size: 24px;
        color: #ff5129;
        vertical-align: sub;
      }
    }
    .payTip {
      margin-top: 22px;
      color: #6e6e6e;
      font-size: 16px;
    }
  }
  .step3,
  .step4,
  .step5 {
    margin-top: 92px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .status {
      color: #393939;
      font-size: 20px;
      margin-top: 21px;
      margin-bottom: 17px;
    }
    .description {
      color: #6e6e6e;
      font-size: 14px;
      margin-bottom: 29px;
    }
    img {
      width: 111px;
      height: 143px;
    }
    .el-button--primary {
      margin-top: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/realNameAuthentication.vue